import { createFileRoute } from "@tanstack/solid-router";
import { CardLab } from "~/components/dev/card-lab";

// Hidden driver-card preview lab, reachable only by typing /dev/cards. Not
// linked from anywhere and code-split into its own chunk, so it costs the normal
// app nothing until visited. See ~/components/dev/card-lab for the controls.
export const Route = createFileRoute("/dev/cards")({
  component: CardLab,
});
